import * as React from "react";
import { connect } from "react-redux";
import { matchesGameMode, matchesVersion } from "./util";
import Dashlet from "../../controls/Dashlet";
import { Icon, IconButton } from "../../controls/TooltipControls";
import { getApplication } from "../../util/application";
import { ComponentEx, translate } from "../../controls/ComponentEx";
import opn from "../../util/opn";
import * as selectors from "../../util/selectors";
import { EmptyPlaceholder, FlexLayout } from "../../controls/api";
import ReactMarkdown from "react-markdown";
import dayjs from "dayjs";
import relativeTimePlugin from "dayjs/plugin/relativeTime"; // import plugin
dayjs.extend(relativeTimePlugin);
class AnnouncementDashlet extends ComponentEx {
    mAppVersion;
    constructor(props) {
        super(props);
        this.mAppVersion = getApplication().version;
    }
    render() {
        const { t, announcements, gameMode } = this.props;
        // Filter announcements by gamemode and version.
        const filtered = announcements
            .filter((announce) => matchesGameMode(announce, gameMode, true) &&
            matchesVersion(announce, this.mAppVersion))
            .sort((lhs, rhs) => new Date(rhs.date).getTime() - new Date(lhs.date).getTime());
        return (React.createElement(Dashlet, { className: "dashlet-announcement", title: t("Announcements") }, filtered.length > 0
            ? this.renderContent(filtered)
            : this.renderPlaceholder()));
    }
    renderPlaceholder() {
        const { t } = this.props;
        return (React.createElement(EmptyPlaceholder, { icon: "announcements", text: t("No Announcements"), subtext: t("No news is good news!") }));
    }
    openLink = (evt) => {
        evt.preventDefault();
        const link = evt.currentTarget.getAttribute("data-link");
        opn(link).catch(() => null);
    };
    renderIcon(announcement) {
        const { t } = this.props;
        const sev = announcement.severity !== undefined
            ? announcement.severity
            : "information";
        const icon = this.severityToIcon(sev);
        if (icon !== undefined) {
            return (React.createElement(Icon, { className: `announcement-icon announcement-icon-${sev}`, name: icon, tooltip: this.severityToTooltip(t, sev) }));
        }
        else {
            return null;
        }
    }
    severityToIcon(severity) {
        switch (severity) {
            case "warning":
                return "feedback-warning";
            case "critical":
                return "dialog-error";
        }
        return undefined;
    }
    severityToTooltip(t, severity) {
        switch (severity) {
            case "warning":
                return t("Warning");
            case "critical":
                return t("Critical");
            case "information":
                return t("Information");
        }
        return "";
    }
    generateExtraPanel(announcement) {
        const { t } = this.props;
        const generateLinkButton = () => {
            return (React.createElement(IconButton, { className: "announcement-open-link-icon", "data-link": announcement.link, icon: "about", tooltip: t("View Issue"), onClick: this.openLink }));
        };
        const renderDate = () => (React.createElement("div", { title: dayjs(announcement.date).toString() }, dayjs().to(announcement.date)));
        const renderTitle = () => (React.createElement("div", { className: "announcement-title" }, announcement.title !== undefined
            ? announcement.title
            : this.severityToTooltip(t, announcement.severity)));
        const renderLink = () => (React.createElement("div", null, announcement.link !== undefined ? generateLinkButton() : null));
        return (React.createElement(FlexLayout, { type: "row", className: "announcement-extras" },
            this.renderIcon(announcement),
            renderTitle(),
            React.createElement("div", { className: "flex-fill" }),
            renderDate(),
            renderLink()));
    }
    generateDescription = (announcement) => {
        const { t } = this.props;
        return (React.createElement(FlexLayout, { type: "row", className: "announcement-description" },
            React.createElement(ReactMarkdown, { allowedElements: ["p", "a", "em", "strong"], unwrapDisallowed: true }, announcement.description)));
    };
    renderContent(filtered) {
        return (React.createElement("div", { className: "announcements-container" }, filtered.map((announcement, id) => (React.createElement("div", { className: "announcement-entry", key: id },
            this.generateExtraPanel(announcement),
            this.generateDescription(announcement))))));
    }
}
const empty = {};
function mapStateToProps(state) {
    return {
        gameMode: selectors.activeGameId(state) || undefined,
        announcements: state.session.announcements.announcements,
    };
}
export default connect(mapStateToProps)(translate(["common"])(AnnouncementDashlet));
